@let toastTitle = title();
@let toastMessage = message();
@let toastOptions = options();

<div
  class="cde-toast-container"
  [ngClass]="{ 'long-text': toastTitle && toastTitle.length > stringLimit }"
  data-testid="toast-notification">
  @if (toastType === 'new-alert-banner-error') {
    <claas-alert-banner
      bannerType="error"
      [title]="toastTitle"
      [description]="toastMessage || ''"
      [inlineAlertBanner]="false"
      [action]="actionName"
      (actionClicked)="action()"
      (closeButtonClicked)="removeToast(toastId)">
    </claas-alert-banner>
  } @else {
    <div class="cde-toast-details" [ngClass]="{ 'long-text': toastTitle && toastTitle.length > stringLimit }">
      <div class="cde-toast-left-box">
        <!-- Show countdown for snackbar components only if 'showCounter' option is true-->
        @if (showCounter) {
          <app-cde-toast-countdown class="mr-2"> </app-cde-toast-countdown>
        }

        @if (toastTitle) {
          <div
            [class]="toastOptions.titleClass"
            class="gap-2"
            [attr.aria-label]="toastTitle"
            [title]="toastTitle"
            [attr.data-testid]="toastTitle">
            <!--Alert icons -->
            @if (toastType !== 'snackbar-large') {
              @if (toastType.indexOf('alert') > -1) {
                <app-alert-icon [iconType]="toastType"> </app-alert-icon>
              }
            }
            <!--Snackbar icons -->
            @if (toastType.indexOf('snackbar') > -1) {
              <app-snackbar-icon [iconType]="toastType"></app-snackbar-icon>
            }
            <span class="cde-toast-title-text" data-testid="title-text">
              {{ toastTitle.length > stringLimit ? (toastTitle | slice: 0 : stringLimit) + '...' : toastTitle }}
            </span>
          </div>
        }
      </div>

      @if (toastMessage && toastOptions.enableHtml) {
        <div type="alert" [class]="toastOptions.messageClass" [innerHTML]="toastMessage"></div>
      }
      @if (toastMessage && !toastOptions.enableHtml) {
        <div type="alert" [class]="toastOptions.messageClass" [attr.aria-label]="toastMessage">
          {{ toastMessage }}
        </div>
      }
      @if (showAction) {
        <button class="ml-4 mat-body-2 cde-toast-action" (click)="action()" data-testid="toast-action">
          {{ actionName }}
        </button>
      }
    </div>
    @if (toastOptions.closeButton) {
      <button (click)="removeToast(toastId)" class="cde-toast-button" data-testid="close-button">
        <claas-icon [removeDefaultColor]="true" class="close-icon flex" iconId="648548" namespace="cc" [size]="24">
        </claas-icon>
      </button>
    }
  }
</div>
